import { render, staticRenderFns } from "./LatentDangerManage.vue?vue&type=template&id=b86d03ac&scoped=true&"
import script from "./LatentDangerManage.vue?vue&type=script&lang=js&"
export * from "./LatentDangerManage.vue?vue&type=script&lang=js&"
import style0 from "./LatentDangerManage.vue?vue&type=style&index=0&id=b86d03ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86d03ac",
  null
  
)

export default component.exports